module.exports = __webpack_public_path__ + "static/media/Академия глубокой релаксации - горный поток.a7868fbe.mp3";